export type ReceiveQuantityKeyEffect =
  | { type: "quantity-digit"; digit: string; buffer: string }
  | { type: "quantity-backspace"; buffer: string }
  | { type: "hold-scan"; buffer: string; rewindDigits: number }
  | { type: "submit-quantity"; buffer: string }
  | { type: "submit-scan"; scanned: string }
  | { type: "ignore"; buffer: string };

function isScanBuffer(buffer: string): boolean {
  return /[^\d]/u.test(buffer);
}

/**
 * Quantity entry owns typed digits. A supplier data matrix breaks out of that:
 * a group separator or any non-digit pulls the in-progress digits back and holds
 * the rest as a label until Enter.
 */
export function applyReceiveQuantityModeKey(buffer: string, key: string): ReceiveQuantityKeyEffect {
  if (key === "Enter") {
    if (isScanBuffer(buffer)) {
      return { type: "submit-scan", scanned: buffer };
    }
    return { type: "submit-quantity", buffer: "" };
  }
  if (key === "Backspace") {
    const next = buffer.slice(0, -1);
    if (isScanBuffer(buffer)) {
      return { type: "hold-scan", buffer: next, rewindDigits: 0 };
    }
    return { type: "quantity-backspace", buffer: next };
  }
  if (key.length !== 1) {
    return { type: "ignore", buffer };
  }
  if (isScanBuffer(buffer)) {
    return { type: "hold-scan", buffer: `${buffer}${key}`, rewindDigits: 0 };
  }
  if (/^\d$/u.test(key)) {
    return { type: "quantity-digit", digit: key, buffer: `${buffer}${key}` };
  }
  return {
    type: "hold-scan",
    buffer: `${buffer}${key}`,
    rewindDigits: buffer.length,
  };
}